import { uniq, keyBy, map } from 'lodash'
import composeReducers from '../composeReducers'
import {
  I_WANT_SUCCESS,
  I_WANT_NOT_SUCCESS,
  SET_ITEM_NOT_OWNED_SUCCESS,
  GET_ITEM_DETAIL_SUCCESS,
  OWNED_ITEM_UPDATED,
  LOGIN_SUCCESS,
} from '../../actions'
import {
  normalizeItem,
  merge2Items,
  itemsById,
  itemUId,
  updateItem,
  swapExternalItem,
  removeOwnerFromItem,
} from './utils'

// Make base reducer for items list
export default (
  prefixActionType,
  config = {
    // This means items collection is driven by owner, and we have the same
    // item multiple item but \w different owner
    ownerDriven: false,

    // Extend list behaviour \w custom reducers...
    reducers: [],
  }
) => {
  const baseDefaultState = {
    loading: false,
    error: null,
    // null instead of [] to discriminating the inital state by the empy state
    ids: null,
    data: {},
    pagination: {
      total: null,
      nextOffset: 0,
    },
    // caching using key taken from history key
    cache: {
      key: null,
      // future info scroll postion ecc
    },
  }

  const injectReducer = composeReducers(...config.reducers)

  const defaultState = {
    ...baseDefaultState,
    ...injectReducer(undefined, {}),
  }

  const nextIds = (items, prevIds, reset) => {
    const newIds = map(items, config.ownerDriven ? itemUId : item => +item.id)
    const ids = reset ? newIds : uniq(prevIds.concat(newIds))
    return ids
  }

  const nextData = (items, prevData, reset) => {
    if (config.ownerDriven) {
      return itemsById(items, reset ? {} : prevData)
    } else {
      const newData = keyBy(items, 'id')
      return reset ? newData : { ...prevData, ...newData }
    }
  }

  const reducer = (prevState = defaultState, action) => {
    const { type, payload, meta, error } = action
    switch (type) {
      case `${prefixActionType}_SUCCESS`: {
        const { reset, total, nextOffset, items } = payload
        const ids = nextIds(items, prevState.ids, reset)
        const data = nextData(items, prevState.data, reset)

        return {
          ...prevState,
          ids,
          data,
          loading: false,
          pagination: {
            total,
            nextOffset,
          },
        }
      }
      case `${prefixActionType}_LOADING`:
        return {
          ...prevState,
          loading: true,
          error: null,
        }
      case `${prefixActionType}_FAILURE`:
        return {
          ...prevState,
          loading: false,
          error,
        }
      case `${prefixActionType}_PUT_IN_CACHE`:
        return {
          ...prevState,
          cache: {
            key: payload.cacheKey,
            index: payload.index,
          },
        }
      // Hitting cache reset current key
      case `${prefixActionType}_HIT_CACHE`:
        return {
          ...prevState,
          cache: {
            key: null,
          },
        }
      // New login current data is trash
      case LOGIN_SUCCESS:
      case `${prefixActionType}_CLEAR_CACHE`:
        return defaultState
      case `${prefixActionType}_UNLOAD`: {
        if (!prevState.cache.key || payload.clearCache) {
          return defaultState
        }
        return {
          ...prevState,
          // Fix the edge case of unloading while loading...
          loading: false,
          error: null,
        }
      }
      case I_WANT_SUCCESS: {
        if (meta && meta.item) {
          // Want an external item so is created
          return swapExternalItem(prevState, meta.item)
        } else {
          return updateItem(prevState, payload, item => ({
            ...item,
            voluto: true,
          }))
        }
      }
      case I_WANT_NOT_SUCCESS:
        return updateItem(prevState, payload, item => ({
          ...item,
          voluto: false,
        }))
      case SET_ITEM_NOT_OWNED_SUCCESS:
        return updateItem(prevState, payload.itemId, item => {
          return removeOwnerFromItem(
            {
              ...item,
              posseduto: false,
            },
            payload.userId
          )
        })
      // always keep in sync! eheh
      case GET_ITEM_DETAIL_SUCCESS:
      case OWNED_ITEM_UPDATED:
        return updateItem(
          swapExternalItem(prevState, payload),
          payload.id,
          item => normalizeItem(payload)
        )
      default:
        return prevState
    }
  }
  return composeReducers(reducer, injectReducer)
}



// WEBPACK FOOTER //
// ./src/reducers/items/base.js